import { IconKakaoSymbolSolid, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface Props {
  text: string;
  handleClick: () => void;
}

export const KakaoPurchaseButton = ({ text, handleClick }: Props) => {
  return (
    <PurchaseButton type='button' onClick={handleClick}>
      <IconKakaoSymbolSolid size={28} />
      <Text variant='Body_15_SemiBold' v3Color='black'>
        {text}
      </Text>
    </PurchaseButton>
  );
};

const PurchaseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 24px;
  background: ${vars.v3Color.kakaoYellow500} !important;
  cursor: pointer;

  svg {
    margin-right: 4px;
  }
`;
